import React from "react";
import { useAuth } from "../auth/useAuth";
import { decimalSeparatorOf } from "./format";
import { loadUnits } from "./unitsStorage";

/**
 * Das Dezimaltrennzeichen dieses Benutzers — für jedes Zahlenfeld mit Nachkommastellen.
 *
 * Ohne es zeigt ein `InputNumber` den Punkt der Programmiersprache, und wer „1,1" eintippt, sieht
 * seine Eingabe verschwinden. Die Angabe genügt: Antd liest und schreibt damit selbst richtig — ein
 * eigener `parser` frisst das Komma wieder weg.
 */
export function useDecimalSeparator(): string {
  const auth = useAuth();
  return React.useMemo(() => decimalSeparatorOf(loadUnits(auth.info?.accountId)), [auth.info?.accountId]);
}
